import { useSyncExternalStore } from 'react'

// TopBar owns the permission-filtered team navigation. Let it render the same
// links inside the home layout without fetching or maintaining a second list.
let host: HTMLDivElement | null = null
const listeners = new Set<() => void>()
const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
const setHost = (element: HTMLDivElement | null) => {
  host = element
  listeners.forEach(listener => listener())
}

export function useHomeNavigationHost() {
  return useSyncExternalStore(subscribe, () => host, () => null)
}

export default function HomeNavigationSlot({ className = 'hp-home-team-navigation' }: { className?: string }) {
  return <div ref={setHost} className={className} />
}
